// extracted by mini-css-extract-plugin
module.exports = {"container":"WeatherInfo_container_2-sDJ","title":"WeatherInfo_title_o1EIe","data":"WeatherInfo_data_39-Z_","label":"WeatherInfo_label_eCSeP","image":"WeatherInfo_image_Jh6Pj"};